export default [function () {
    return {
        restrict: 'E',
        link: function (scope, elem, attrs) {
            elem.on('click', function (e) {
                if (attrs.disabled) {
                    e.preventDefault(); // prevent link click
                }
            });
        }
    };
}];



// WEBPACK FOOTER //
// ./frontend/storefront/app/modules/page/directives/disabled.directive.js